import {Component, OnInit, Input} from '@angular/core';
import {NgbActiveModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {LogService} from '../../services/log.service';
import {Log} from '../../model/log';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {YearsShowComponent} from '../../views/setting/years/years-show/years-show.component';
import {TranslateService} from "@ngx-translate/core";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {validate} from "codelyzer/walkerFactory/walkerFn";
// import {ItemsGroup} from "../../views/setting/usersGroups/usersGroups";
import {User} from "../../model";
import {UserService} from "../../services/user.service";
import {Message} from "primeng/api";
import {YearService} from "../../views/setting/years/year.service";

@Component({
    selector: 'app-user-profile',
    templateUrl: './years-list.component.html',
    styleUrls: ['./years-list.component.scss'],
    providers: []
})
export class YearsListComponent implements OnInit {
    id: string;
    public user: User;
    userData: any;
    public logs: Log[];

    msgs: Message[] = [];
    @Input() rowId;
    @Input() refRec: any;
    @Input() refShow;
    behalf:string;
    modalRef: NgbModalRef;
    form: FormGroup;
    sts:string;
    year:any;
    public newYear:any;
    public years:any[]=[];

    constructor(public activeModal: NgbActiveModal,
                public logService: LogService,
                private userService: UserService,
                private YearService:YearService,
                public translate: TranslateService,
                private formBuilder: FormBuilder,
                private modalService: NgbModal,) {
        this.YearService.getAll().subscribe(
            data=>{
                this.years = data.dataarr.data;
            }
        );
    }

    ngOnInit() {
    }


    switchYear(id:any){
        const user = JSON.parse(localStorage.getItem('currentUser'));
        user.year = id;
        let array:any;
        array = {'year': id};

        this.YearService.switchYear(array).subscribe(
            data=>{
                this.years = data.year;
            }
        );

        localStorage.setItem('currentUser', JSON.stringify(user));
        
        this.year = id;
        this.close();
    }

    close() {
        this.activeModal.dismiss('done');
    }
}


// WEBPACK FOOTER //
// ./src/app/components/years-list/years-list.component.ts